export default {
  'Manual Transcripts 1040C': {
    period: 'tax',
    source: 'manual_transcript',
    form: '1040C'
  },
  'Tax Returns 1040C': {
    period: 'tax',
    source: 'manual_document',
    form: '1040C'
  },
  Average: {
    period: 'interim',
    source: 'manual_document',
    form: null
  }
}
